import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { WebHookReceiverLogsAuditStateClass } from './interfaces/WebHookReceiverLogsAuditStateClass' 
import { start } from 'repl'

const initialState: WebHookReceiverLogsAuditStateClass = {
    isLoading: false,
    status: 'idle',
    WebHookReceiverLogsAuditList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: " ",
    ResponseBody: "",
    RequestURI: "",
    ActionDescription: "",
    checkedRecordsArray: [],
    isAllUnChecked: true,
    recordsFiltered: 0,
    WebHookReceiverLogCheckedIds:[],
    sortIndex:0,
    sortDirection:"asc",
    isSearch:false,
    isSort:false,
}
interface IThunkApi {
    state: {
        webHookReceiverLogAudit : WebHookReceiverLogsAuditStateClass;
    },
}
export const getWebhookReceiverLogAuditDatatableAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'WebHookReceiverLogAudit/V2/getWebhookReceiverLogAuditDatatable',
        async (arg, thunkApi) => {
            const {search, webhookreceiverlogid,currentPage:currentPage,pageSize,start ,order,orderDir} = arg;
            const response = await fetchAPI('api/V2/Logs/WebhookReceiverLogAuditDatatable/' + webhookreceiverlogid+'/'+currentPage+'/'+pageSize+'/'+start+ '/' + order +'/'+ orderDir +'/'+search, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )


export const webHookReceiverLogAuditSlice = createSlice({
    name: 'webHookReceiverLogAudit',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.WebHookReceiverLogsAuditList = [];
            state.WebHookReceiverLogCheckedIds = [];
        },
        setSortConfig: (state, action) => {
            const {Index,Dir} = action.payload;
            state.sortDirection = Dir;
            state.sortIndex = Index;
            state.isSort = true;
           
         },
         setPageSize: (state, action) => {
            state.pageSize = action.payload;
           
         },
         setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
            state.isSearch = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWebhookReceiverLogAuditDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getWebhookReceiverLogAuditDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (payload.Data.data !== undefined) {
                    state.WebHookReceiverLogsAuditList = JSON.parse(payload.Data.data);
                    state.selectedRecord = {};
                    state.currentPage = payload.Data.currentPage;
                    state.start = payload.Data.start
                    state.totalItems = payload.Data.recordsTotal;
                    state.search = payload.Data.search;
                    state.recordsFiltered = payload.Data.recordsFiltered;
                    state.pageSize = payload.Data.pageSize;
                    state.isSearch = false;
                    state.isReload = false;
                    state.isSearch = false;
                    state.isSort = false;
                    state.isLoading = false;
                     
                }
            })
            .addCase(getWebhookReceiverLogAuditDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isSearch = false;
                    state.isSort = false;
                    state.isLoading = false;
            })
           
    }
})

export const {resetSelectedRecordObjectInState,setSortConfig,setPageSize,setSearchValue} = webHookReceiverLogAuditSlice.actions
export const webHookReceiverLogsAuditStateClass = (state: RootState) => state.webHookReceiverLogAudit
export default webHookReceiverLogAuditSlice.reducer
